import * as React from 'react'
import { Tab, TabsProps, TabsButtonsProps } from './types'
import { TabButton } from './TabButton'

export const Tabs: React.FC<TabsProps> = (props) => {
    const { tabs, activeTabId, className } = props
    const activeTab = tabs.find((tab) => tab.id === activeTabId)

    return (
        <div className={className}>
            <TabsButtons {...props} />
            {activeTab && <TabContent tab={activeTab} />}
        </div>
    )
}

export const TabsButtons: React.FC<TabsButtonsProps> = ({
    tabs,
    onChange,
    activeTabId,
}) => {
    return (
        <div className="relative flex">
            <div
                className="relative z-10 flex gap-4 px-6"
                data-walkthrough="tabs"
            >
                {tabs.map((tab) => (
                    <TabButton
                        key={tab.id}
                        {...tab}
                        isActive={activeTabId === tab.id}
                        onClick={() => {
                            onChange?.(tab.id)
                        }}
                    />
                ))}
            </div>
            <div className="absolute inset-0 border-b-2 border-neutral-200" />
        </div>
    )
}

interface TabContentProps {
    tab: Tab
}

const TabContent: React.FC<TabContentProps> = ({ tab }) => {
    const { id, content } = tab
    return <div data-testid={`content-${id}`}>{content}</div>
}
